module.exports = __webpack_public_path__ + "static/media/chodba-prizemi.94637a0d.jpg";